import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { menuToggler } from '@bd/bdcore-utilities';
import { FavoritesStatus } from './Favorites';
import ScheduleModal from './ScheduleModal';
import ContactModal from './ContactModal';
import GetUpdatesModal from './GetUpdatesModal';
import { colors, typography } from '../styles';

const styles = css`
  height: 60px;
  width: 100%;
  color: ${colors.body};
  background-color: ${colors.white};
  list-style: none;
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-bottom: 0;
  .MobileNav_navItem {
    border-right: 1px solid ${colors.neutralDark};
    height: 60px;
    flex-grow: 1;
    position: relative;
    a, span {
      color: ${colors.body};
    }
    &:nth-child(2) {
      .MobileNav_menu {
        left: -30px;
      }
    }
    &:last-child {
      .MobileNav_menu {
        left: auto;
        right: -43px;
      }
      .MobileNav_menuItem a, .MobileNav_menuItem-span {
        padding: 4px 0;
      }
    }
  }
  .MobileNav_navHeading {
    height: 60px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 600;
    text-transform: uppercase;
    cursor: pointer;
    transition: all .3s ease;
    font-family: ${typography.Condensed};
    text-align: center;
    z-index: 2;
    ${'' /* &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand2};
      position: relative;
      margin: 0 0 0 5px;
    } */}
    &:hover, &:focus {
      outline: none;
      border: none;
      color: ${colors.white};
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: -6px;
        left: 50%;
        width: 20px;
        height: 20px;
        background-color: ${colors.brand1};
        transform: rotate(45deg);
        margin-left: -10px;
        z-index: 1;
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${colors.brand1};
        z-index: -1;
      }
    }
    &-link {
      &::after {
        display: none;
      }
    }
  }
  .MobileNav_menu {
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    position: relative;
    transition: all .3s ease;
    transition-delay: .1s;
    opacity: 0;
    transform: scaleY(0);
    transform-origin: bottom center;
    position: absolute;
    top: auto;
    bottom: 60px;
    left: 0;
    background-color: ${colors.white};
    color: ${colors.white};
    padding: 30px;
    font-size: 15px;
    text-align: left;
    box-shadow: inset 0px -11px 8px -10px rgba(39,39,39,0.2);
  }
  .MobileNav_menu-active {
    opacity: 1;
    transform: scaleY(1);
    display: block;
  }
  .MobileNav_menuItemHeading {
    font-size: 17px;
    font-weight: 600;
    font-family: ${typography.Serif};
    color: ${colors.body};
    margin: 0 -30px 8px -30px;
    padding: 0 30px 0 30px;
    text-align: left;
    &:not(:first-child) {
      margin: 20px -30px 8px -30px;
      padding: 20px 30px 0 30px;
      border-top: 1px solid ${colors.neutral};
    }
    &:focus {
      outline: 0;
    }
  }
  .MobileNav_menuItem a, .MobileNav_menuItem span {
    color: ${colors.brand1Dark} !important;
    padding: 4px 0;
    display: block;
    transition: all .3s ease;
    font-weight: 700;
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: .5px;
    white-space: nowrap;
    text-align: left;
  }
  .btn {
    color: ${colors.black} !important;
    padding: 8px 12px !important;
    border-radius: 0 !important;
    margin: 10px 10px 0 0;
  }
`;

function MobileNav({ areas, isActiveMenu, activateMenu, widget, agent, builder, community }) {
  return (
    <ul className={styles} >
      {
        areas.filter(area => area.isMetro).map(metro => (
          <li className="MobileNav_navItem" key={metro.name}>
            <span tabIndex={0} role="button" className="MobileNav_navHeading" onClick={activateMenu(metro.name)} onKeyDown={activateMenu(metro.name)}>{metro.name}</span>
            <ul className={`${isActiveMenu(metro.name) ? 'MobileNav_menu-active' : ''} MobileNav_menu`}>
              <li className="MobileNav_menuItemHeading">Products</li>
              <li className="MobileNav_menuItem"><Link name="communities" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Communities</Link></li>
              <li className="MobileNav_menuItem"><Link name="homes" params={{ communityMarketAreaMetro: get(metro, 'name') }}>Available Homes</Link></li>
              {
                metro.name === 'California' &&
                <li className="MobileNav_menuItem"><Link name="elliott-reserve">Turnkey Custom Homes</Link></li>
              }
              <li className="MobileNav_menuItemHeading">Shop By Area</li>
              {
                areas.filter(area => area.parentMetro === metro.name).map(submetro => (
                  <li className="MobileNav_menuItem" key={submetro.name}>
                    <Link
                      name="communities"
                      params={{
                        communityMarketAreaMetro: get(metro, 'name'),
                        communityMarketAreaSubMetro: get(submetro, 'name'),
                      }}
                      className="Menu_submetroListItemLink"
                    >
                      {submetro.name} New Homes
                    </Link>
                  </li>
                ))
              }
            </ul>
          </li>
        ))
      }
      <li className="MobileNav_navItem">
        <span tabIndex={0} role="button" className="MobileNav_navHeading" onClick={activateMenu('contact')} onKeyDown={activateMenu('contact')}>Get In Touch</span>
        <ul className={`${isActiveMenu('contact') ? 'MobileNav_menu-active' : ''} MobileNav_menu`}>
          {
            community &&
            get(community, 'schedule_appointment_link') &&
            <li className="MobileNav_menuItem">
              <ScheduleModal community={community}>
                <span className="MobileNav_menuItem-span">
                  Schedule Appointment
                </span>
              </ScheduleModal>
            </li>
          }
          {
            !community &&
            <li className="MobileNav_menuItem" >
              <Link name="schedule-appointment">
                  Schedule Appointment
              </Link>
            </li>
          }
          <li className="MobileNav_menuItem"><GetUpdatesModal>Get Updates</GetUpdatesModal></li>
          <li className="MobileNav_menuItem"><ContactModal>Contact Us</ContactModal></li>
          <li className="MobileNav_menuItem">
            <div className="d-flex">
              <span>
                <a href={`tel:${get(agent, 'telephone', get(builder, 'telephone', '')).replace(/[^0-9]/g, '')}`} className="btn btn-brand3">Call</a>
              </span>
              {
                get(agent, 'text_number') &&
                <span><a href={`sms:${get(agent, 'text_number', '').replace(/[^0-9]/g, '')}`} className="btn btn-brand2">Text</a></span>
              }
            </div>
          </li>
        </ul>
      </li>
      {
        get(widget, 'my_favorites') &&
        <li>
          <FavoritesStatus />
          <div>Favorites</div>
        </li>
      }
    </ul>
  );
}

MobileNav.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  activateMenu: PropTypes.func.isRequired,
  widget: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
  community: PropTypes.object,
};

MobileNav.defaultProps = {
  community: undefined,
};

export default withData(
  {
    areas: true,
    widget: 'website_configuration',
    builder: true,
    agent: true,
    community: true,
  },
  {
    required: {
      builder: true,
      agent: true,
    },
  },
)(menuToggler((MobileNav)));



// WEBPACK FOOTER //
// ./src/components/MobileNav.js